module.exports = __webpack_public_path__ + "img/banner_1.9a7b3a25.jpg";